import { render, staticRenderFns } from "./SinceTill.vue?vue&type=template&id=2d2b84f6&"
import script from "./SinceTill.vue?vue&type=script&setup=true&lang=js&"
export * from "./SinceTill.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports